<template>
    <button
        class="w-full flex flex-col gap-y-2 border rounded-lgr py-3 px-5 hover:bg-[#E5E7FE] hover:border-[#8489CF] transition-colors duration-150 text-valence-gray-900 text-start"
        :class="isSelected ? 'border-[#8489CF] bg-[#F2F3FE]' : 'border-valence-grey-300 bg-white'"
        type="button"
        @click="$emit('click')">
        <div class="flex flex-row gap-2.5">
            <i class="bi grow-0" :class="icon" aria-hidden="true"></i>
            <div class="flex flex-col gap-1 grow">
                <div class="body-small-semibold py-0.5">{{ label }}</div>
                <SkeletonLoader v-if="isLoading" class="w-full h-9 rounded-lgr" />
                <div v-else class="title-section">{{ valueDisplay }}</div>
            </div>
        </div>
    </button>
</template>

<script setup lang="ts">
import SkeletonLoader from "~vue/components/SkeletonLoader.vue";
import { computed } from "vue";

const {
    isLoading = false,
    icon = "bi bi-stars",
    label = "",
    value = "",
    isSelected = false,
} = defineProps<{
    isLoading?: boolean;
    icon?: string;
    label?: string;
    value?: string | number;
    isSelected?: boolean;
}>();

defineEmits<{
    click: [];
}>();

const valueDisplay = computed(() => {
    if (typeof value === "number") {
        return value.toLocaleString();
    }
    const numberValue = Number.parseFloat(value);
    if (Number.isNaN(numberValue)) {
        return value || "--";
    }
    return numberValue.toLocaleString();
});
</script>
